<template>
  <b-row>
    <b-col md="6">
      <p>{{ $t('request-form-text') | capitalize }}</p>
      <ticket-form />
    </b-col>
  </b-row>
</template>

<script>
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import TicketForm from '@/components/helpdesk/TicketForm.vue';

export default {
  name: 'Helpdesk',
  mixins: [
    BreadcrumbsManager,
  ],
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t('helpdesk'),
        },
      ],
    };
  },
  components: { TicketForm },
};
</script>

<style scoped>

</style>
